<template>
  <div class="container">
    <div class="bubbles">
      <span v-for="i in 50" :key="i" :style="randomBubbleStyle()"></span>
    </div>
    <div class="logo-container">
      <img src="../assets/vite2.svg" alt="Logo" class="logo spinning" />
      <!-- <div class="version-tag">v1.4.6</div> -->
    </div>
    
    <h1>Steam清单下载工具</h1>
    <div class="card">
      <h2>输入游戏AppID获取配置文件</h2>
      <div class="form-group">
        <label for="appId">游戏App ID:</label>
        <input 
          type="text" 
          v-model="appId" 
          placeholder="请输入Steam游戏的App ID" 
          :disabled="loading"
        />
      </div>
      
      <div class="form-group">
        <label for="token">
          GitHub Token (可选):
          <span class="tooltip-icon" @mouseover="showTokenTip = true" @mouseleave="showTokenTip = false">?</span>
          <div class="tooltip" v-if="showTokenTip">
            <p>如遇到API请求限制，可提供GitHub个人访问令牌。申请步骤：</p>
            <ol>
              <li>访问 <a href="https://github.com/settings/tokens" target="_blank" style="color:#4a88ff">github.com/settings/tokens</a></li>
              <li>点击"Generate new token" > "Generate new token (classic)"</li>
              <li>填写描述（如"Steam清单下载"）</li>
              <li>选择过期时间（建议90天）</li>
              <li>权限勾选：public_repo</li>
              <li>点击"Generate token"按钮</li>
              <li>复制生成的token填入此处</li>
            </ol>
            <p>如不填写将使用服务器默认Token</p>
          </div>
        </label>
        <input 
          type="password" 
          v-model="token" 
          placeholder="可选：输入您的GitHub Token" 
          :disabled="loading"
        />
      </div>
      
      <button 
        @click="downloadFiles" 
        :disabled="!isValidAppId || loading"
        class="download-btn"
      >
        <span v-if="loading">{{ processStatus }}</span>
        <span v-else>下载清单文件</span>
      </button>
      
      <div v-if="loading && processMsg" class="process-info">
        <div class="progress-bar">
          <div class="progress" :style="{ width: processProgress + '%' }"></div>
        </div>
        <p>{{ processMsg }}</p>
      </div>
      
      <div class="error" v-if="error">{{ error }}</div>
    </div>
    
    <div class="info-card">
      <!-- <h3>使用说明</h3>
      <p>1. 输入Steam游戏的App ID（可以从Steam商店页面URL中获取，如https://store.steampowered.com/app/<strong>730</strong>/，其中730就是App ID）</p>
      <p>2. 可选：填入GitHub个人访问令牌（如API请求次数受限时使用）</p>
      <p>3. 点击"下载配置文件"按钮，等待处理完成</p>
      <p>4. 下载完成后解压文件，将得到的文件放入对应目录</p>
      <p>5. 根据README.txt中的详细说明进行操作</p>
      <p>6. 重启Steam客户端以应用更改</p>
      
      <div class="divider"></div> -->
      
      <!-- <h3>常见问题</h3>
      <div class="faq-item">
        <h4>如何查找游戏的App ID？</h4>
        <p>访问Steam商店中该游戏的页面，在地址栏URL中可以找到，例如：https://store.steampowered.com/app/<strong>730</strong>/，其中730就是App ID。</p>
        <p>您也可以通过以下工具快速查找游戏的App ID：</p>
        <div class="tool-links">
          <a href="https://steamdb.info/" target="_blank" class="tool-link">SteamDB</a>
          <a href="https://steamui.com/" target="_blank" class="tool-link">SteamUI</a>
        </div>
      </div> -->
      <!-- <div class="faq-item">
        <h4>下载的文件应该放在哪里？</h4>
        <p>请按照下载文件中的README.txt说明操作，一般需要放入SteamTools工作目录下。</p>
      </div> -->
      <div class="faq-item">
        <h4>致倒卖者/Note for resellers</h4>
        <li>如果再发现有倒卖清单的行为，清单将不会再更新。</li>
        <li>If the list is resold again, the list will not be updated</li>
        <li>届时本站将永久关闭。</li>
        <li>At that time, the site will be permanently closed</li>
        <li>请倒卖人员好自为之。</li>
        <li>Please resell people to do it themselves</li>

      </div>
      <div class="faq-item">
        <h4>为什么需要GitHub Token？</h4>
        <p>GitHub API有请求限制，如果遇到"API rate limit exceeded"错误，请提供自己的Token以获得更高的请求配额。</p>
      </div>
    </div>
    
    <!-- <div class="github-link">
      <a href="https://github.com/ikun0014/OneKey" target="_blank">
        <svg height="20" class="github-icon" viewBox="0 0 16 16" width="20">
          <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
        </svg>
        GitHub仓库
      </a>
    </div> -->
    
    <!-- <div class="thanks-section">
      <h3>感谢开源仓库支持</h3>
      <div class="repo-links">
        <a href="https://github.com/SteamAutoCracks/ManifestHub" target="_blank" class="repo-link">
          <svg height="16" class="github-icon" viewBox="0 0 16 16" width="16">
            <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
          </svg>
          SteamAutoCracks/ManifestHub
        </a>
        <a href="https://github.com/ikun0014/ManifestHub" target="_blank" class="repo-link">
          <svg height="16" class="github-icon" viewBox="0 0 16 16" width="16">
            <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
          </svg>
          ikun0014/ManifestHub
        </a>
        <a href="https://github.com/Auiowu/ManifestAutoUpdate" target="_blank" class="repo-link">
          <svg height="16" class="github-icon" viewBox="0 0 16 16" width="16">
            <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
          </svg>
          Auiowu/ManifestAutoUpdate
        </a>
      </div>
    </div>
     -->
    <div class="contact-section">
      <h3>联系方式</h3>
      <a href="https://t.me/Assiw8" target="_blank" class="contact-link">
        <svg class="telegram-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18.671-.56 2.295-1.02 4.236l-1.32 5.57c-.101.414-.3.744-.63.744-.239 0-.539-.13-.87-.346l-2.42-1.621-1.33 1.17c-.15.136-.27.249-.6.249-.12 0-.24-.028-.345-.116l.12-2.37 4.771-3.833c.21-.176.03-.27-.12-.12l-5.889 3.277-2.531-.84c-.55-.176-.561-.561.12-.84l9.871-3.709c.45-.176.87.104.75.55z" fill="currentColor"/>
        </svg>
        Telegram: @Assiw8
      </a>
      <a href="#" target="_blank" class="contact-link">
        <svg class="qq-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path d="M12.003 2c-2.265 0-6.29 1.364-6.29 7.325 0 1.735-.03 3.367.41 4.98.33 1.19.91 2.21 1.5 3.175.45.74 1.03 1.36 1.68 1.92.65.56 1.37 1.04 2.13 1.42.5.25 1.01.48 1.53.69l.97.33c.26.09.39.13.51.14h.03c.1-.01.23-.05.48-.14l.97-.33c.52-.21 1.03-.44 1.53-.69.76-.38 1.48-.86 2.13-1.42.65-.56 1.23-1.18 1.68-1.92.59-.97 1.17-1.99 1.5-3.17.44-1.61.41-3.24.41-4.98 0-5.96-4.025-7.325-6.29-7.325zm-1.003 16.96c-.37-.22-.74-.48-1.1-.78-.77-.64-1.42-1.38-1.91-2.16-.5-.8-.92-1.62-1.29-2.46-.4-.94-.71-1.91-.65-2.97.06-1.06.37-2.08 1.03-2.83.63-.72 1.5-1.12 2.41-1.33.68-.16 1.4-.19 2.1-.09.69.1 1.36.33 1.98.65.6.31 1.17.71 1.58 1.26.2.27.36.58.48.9.12.33.19.67.21 1.02.04.7-.05 1.38-.23 2.03-.19.65-.44 1.29-.75 1.9-.57 1.1-1.3 2.12-2.18 2.96-.42.4-.89.77-1.38 1.09l-1.3-.33c.17-.29.31-.59.43-.91.12-.32.22-.65.28-.99.06-.34.09-.69.08-1.03-.01-.35-.05-.7-.13-1.03-.07-.33-.18-.64-.33-.94-.15-.3-.34-.57-.57-.81-.23-.24-.5-.44-.8-.59-.3-.15-.62-.25-.96-.3-.34-.05-.69-.05-1.03 0-.35.05-.68.15-.99.3-.3.15-.58.35-.81.59-.23.24-.42.51-.57.81-.15.3-.26.61-.33.94-.08.33-.13.68-.13 1.03-.01.35.02.7.08 1.03.06.34.16.67.28.99.12.32.26.62.43.91l-1.28.33zm6.93-2.76c-.17-.2-.33-.41-.47-.64-.14-.23-.27-.46-.38-.71-.11-.25-.2-.5-.27-.76-.07-.27-.11-.54-.14-.82-.03-.28-.03-.55 0-.83.03-.28.07-.55.14-.82.07-.27.17-.52.29-.77.12-.25.26-.48.41-.7.15-.22.32-.42.5-.61.18-.19.38-.36.59-.52.21-.16.43-.3.67-.42.23-.12.48-.22.73-.3.25-.08.51-.14.78-.17.27-.03.54-.04.81-.02.27.02.54.06.8.12.26.06.52.14.77.24.25.1.49.22.71.36.22.14.43.3.62.48.19.18.37.37.53.58.16.21.3.43.42.66.12.23.22.47.3.72.08.25.14.5.18.76.04.26.05.53.05.79 0 .26-.03.52-.07.78-.04.26-.1.51-.18.76-.08.25-.18.49-.3.72-.12.23-.26.45-.42.66-.16.21-.34.4-.53.58-.19.18-.4.34-.62.48-.22.14-.46.26-.71.36-.25.1-.51.18-.77.24-.26.06-.53.1-.8.12-.27.02-.54.01-.81-.02-.27-.03-.53-.09-.78-.17-.25-.08-.5-.18-.73-.3-.24-.12-.46-.26-.67-.42-.21-.16-.41-.33-.59-.52-.18-.19-.35-.39-.5-.61-.15-.22-.29-.45-.41-.7-.12-.25-.22-.5-.29-.77-.07-.27-.12-.54-.15-.82-.03-.28-.03-.55 0-.83.03-.28.07-.55.14-.82.07-.26.16-.51.27-.76.11-.25.24-.48.38-.71.14-.23.3-.44.47-.64z" fill="currentColor"/>
        </svg>
        QQ: 3920746302
      </a>
      <p class="contact-info">欢迎联系我进行页面管理、投稿发布、网页开发、项目开发等合作</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { MD5 } from 'crypto-js';

export default {
  name: 'HelloWorld',
  data() {
    return {
      appId: '',
      token: '',
      loading: false,
      error: '',
      showTokenTip: false,
      processStatus: '处理中...',
      processMsg: '',
      processProgress: 0
    };
  },
  
  computed: {
    isValidAppId() {
      return /^\d+$/.test(this.appId);
    }
  },

  mounted() {
    // 移除开发者工具检测相关代码
  },

  beforeUnmount() {
    // 移除清理相关代码
  },
  
  methods: {
    getSecretKeyParts() {
      const p1 = "89" + "32m";
      const p2 = "fo" + "iOI#M";
      const p3 = "Om" + "ff42m";
      const p4 = "iog" + "poa";
      return [p1, p2, p3, p4].join('');
    },
    
    generateSignature(params) {
      const sortedParams = {};
      Object.keys(params).sort().forEach(key => {
        sortedParams[key] = params[key];
      });
      
      sortedParams.key = this.getSecretKeyParts();
      
      const signString = Object.entries(sortedParams)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      
      return MD5(signString).toString();
    },
    
    async downloadFiles() {
      if (!this.isValidAppId) {
        this.error = '请输入有效的App ID（仅数字）';
        return;
      }
      
      this.loading = true;
      this.error = '';
      this.processMsg = '正在初始化请求...';
      this.processProgress = 5;
      
      try {
        // 准备参数
        const timestamp = Math.floor(Date.now() / 1000);
        const params = {
          appId: Number(this.appId),
          timestamp
        };
        
        // 如果用户提供了Token，添加到请求中
        if (this.token.trim()) {
          params.token = this.token.trim();
          this.processMsg = '使用用户提供的Token发送请求...';
        } else {
          this.processMsg = '使用系统Token发送请求...';
        }
        
        // 计算签名
        const signature = this.generateSignature(params);
        
        this.processProgress = 10;
        this.processStatus = '请求中...';
        
        // 使用较长的超时时间，因为清单生成可能需要较长时间
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 120000); // 2分钟超时
        
        this.processMsg = '正在连接服务器，查询清单信息...';
        this.processProgress = 20;
        
        // 设置请求开始时间
        const startTime = Date.now();
        
        // 增加进度更新
        const progressInterval = setInterval(() => {
          // 如果还在请求中，逐渐增加进度条，最多到80%
          if (this.loading && this.processProgress < 80) {
            this.processProgress += 1;
            
            // 根据已经过的时间更新状态消息
            const elapsedTime = Math.floor((Date.now() - startTime) / 1000);
            if (elapsedTime > 60) {
              this.processMsg = `仍在处理中，请耐心等待...（${elapsedTime}秒）`;
              this.processStatus = '处理清单文件中...';
            } else if (elapsedTime > 30) {
              this.processMsg = '正在生成清单文件，这可能需要一些时间...';
              this.processStatus = '处理清单文件中...';
            } else if (elapsedTime > 10) {
              this.processMsg = '正在查询Steam仓库，获取最新清单...';
              this.processStatus = '数据获取中...';
            }
          }
        }, 1000);
        
        const response = await axios({
          method: 'post',
          url: '/api/download',
          data: {
            ...params,
            signature
          },
          responseType: 'blob',
          signal: controller.signal,
          timeout: 120000,
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        // 清除定时器
        clearTimeout(timeoutId);
        clearInterval(progressInterval);
        
        this.processStatus = '准备下载...';
        this.processMsg = '清单文件已生成，正在准备下载...';
        this.processProgress = 90;
        
        // 创建Blob URL并触发下载
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        // 从响应头获取文件名
        const contentDisposition = response.headers['content-disposition'];
        let filename = `Assiw_${this.appId}_清单.zip`;
        if (contentDisposition) {
          const matches = /filename=([^;]+)/.exec(contentDisposition);
          if (matches && matches[1]) {
            filename = decodeURIComponent(matches[1]);
          }
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        
        this.processMsg = '下载已就绪，即将开始下载...';
        this.processProgress = 95;
        
        // 短暂延迟以显示下载状态
        setTimeout(() => {
          link.click();
          document.body.removeChild(link);
          
          this.processMsg = '下载完成！';
          this.processProgress = 100;
          this.processStatus = '下载成功！';
          
          // 短暂显示成功消息后重置状态
          setTimeout(() => {
            this.loading = false;
            this.processMsg = '';
            this.processProgress = 0;
          }, 2000);
        }, 500);
        
      } catch (err) {
        this.processStatus = '发生错误';
        this.processProgress = 0;
        
        console.error('API请求错误:', err);
        
        if (err.name === 'AbortError' || err.code === 'ECONNABORTED') {
          this.error = '请求超时，服务器处理时间过长，请稍后再试';
        } else if (err.response) {
          if (err.response.status === 404) {
            this.error = 'API接口不存在，请检查服务器配置';
          } else if (err.response.status === 403) {
            this.error = '签名验证失败，请重试';
          } else if (err.response.data) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result);
                this.error = errorData.error || `请求失败(${err.response.status})，请稍后重试`;
              } catch (e) {
                this.error = `请求失败(${err.response.status})，请稍后重试`;
              }
            };
            reader.onerror = () => {
              this.error = `请求失败(${err.response.status})，请稍后重试`;
            };
            reader.readAsText(err.response.data);
          } else {
            this.error = `服务器返回错误(${err.response.status})`;
          }
        } else if (err.request) {
          this.error = '无法连接到服务器，请检查网络和服务器地址';
        } else {
          this.error = `发生未知错误: ${err.message || '请稍后重试'}`;
        }
        
        this.loading = false;
        this.processMsg = '';
      }
    },
    randomBubbleStyle() {
      const size = Math.random() * 60 + 10;  // 10 to 70px
      const left = Math.random() * 100;      // 0 to 100%
      const duration = Math.random() * 25 + 15; // 15 to 40s
      const delay = Math.random() * 10;      // 0 to 10s
      const opacity = Math.random() * 0.2 + 0.05; // 0.05 to 0.25 opacity
      
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        'animation-duration': `${duration}s`,
        'animation-delay': `${delay}s`,
        'background': this.randomGradientColor(),
        'opacity': opacity
      };
    },
    randomGradientColor() {
      const primaryColors = [
        'rgba(123, 104, 238, 0.8)', // primary-color
        'rgba(198, 103, 248, 0.8)', // accent-color
        'rgba(90, 200, 250, 0.8)'   // highlight-color
      ];
      const idx = Math.floor(Math.random() * primaryColors.length);
      return `radial-gradient(circle, ${primaryColors[idx]}, transparent)`;
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.bubbles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
  pointer-events: none;
}

.bubbles span {
  position: absolute;
  bottom: -100px;
  border-radius: 50%;
  box-shadow: 0 0 15px rgba(123, 104, 238, 0.2), inset 0 0 10px rgba(255, 255, 255, 0.3);
  animation: rise linear infinite;
  filter: blur(3px);
}

@keyframes rise {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: var(--bubble-opacity, 0.1);
  }
  90% {
    opacity: var(--bubble-opacity, 0.1);
  }
  100% {
    transform: translateY(-1000px) rotate(360deg);
    opacity: 0;
  }
}

.logo-container {
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.logo {
  width: 100px;
  height: 100px;
  filter: drop-shadow(0 0 15px rgba(123, 104, 238, 0.7));
  transition: filter 0.3s ease;
}

.logo:hover {
  filter: drop-shadow(0 0 20px rgba(123, 104, 238, 1));
}

.spinning {
  animation: spin 10s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

h1 {
  text-align: center;
  margin-bottom: 30px;
  color: var(--text-color);
  text-shadow: 0 0 10px rgba(123, 104, 238, 0.5);
  position: relative;
  overflow: hidden;
  animation: textGlow 3s infinite alternate;
}

@keyframes textGlow {
  from {
    text-shadow: 0 0 4px rgba(123, 104, 238, 0.3);
  }
  to {
    text-shadow: 0 0 12px rgba(123, 104, 238, 0.8);
  }
}

h2 {
  color: var(--text-color);
  margin-bottom: 20px;
}

.card {
  background: var(--card-bg);
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: var(--box-shadow);
  border: 1px solid var(--border-color);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: fadeIn 0.6s ease-out;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: var(--glow-shadow), var(--box-shadow);
}

.form-group {
  margin-bottom: 20px;
  position: relative;
  animation: slideUp 0.5s ease-out both;
}

.form-group:nth-child(2) {
  animation-delay: 0.1s;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: var(--text-color);
}

input {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 16px;
  background-color: var(--secondary-color);
  color: var(--text-color);
  transition: all 0.3s;
}

input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(138, 43, 226, 0.2);
}

input::placeholder {
  color: #888888;
}

.download-btn {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  color: white;
  border: none;
  padding: 12px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
  animation: slideUp 0.5s ease-out 0.2s both;
}

.download-btn:before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.7s ease;
  z-index: -1;
}

.download-btn:hover:before {
  left: 100%;
}

.download-btn:hover {
  background: linear-gradient(135deg, var(--accent-color) 0%, var(--primary-color) 100%);
  box-shadow: 0 0 15px rgba(123, 104, 238, 0.5);
}

.download-btn:disabled {
  background: #555555;
  cursor: not-allowed;
}

.error {
  color: var(--error-color);
  margin-top: 15px;
}

.info-card {
  background: var(--info-card-bg);
  border-radius: 8px;
  padding: 20px;
  box-shadow: var(--box-shadow);
  border: 1px solid var(--border-color);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: slideUp 0.5s ease-out 0.3s both;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--glow-shadow), var(--box-shadow);
}

.info-card h3 {
  color: var(--primary-color);
  margin-bottom: 15px;
}

.info-card p {
  margin: 8px 0;
  color: var(--text-color);
}

.tooltip-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  background-color: var(--primary-color);
  color: white;
  text-align: center;
  border-radius: 50%;
  font-size: 12px;
  margin-left: 5px;
  cursor: help;
}

.tooltip {
  position: absolute;
  top: -5px;
  left: 100%;
  width: 320px;
  background-color: var(--tooltip-bg);
  color: var(--text-color);
  padding: 15px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 100;
  font-weight: normal;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  border: 1px solid var(--border-color);
  line-height: 1.5;
}

.tooltip p {
  margin-bottom: 8px;
}

.tooltip ol {
  padding-left: 20px;
  margin-bottom: 8px;
}

.tooltip li {
  margin-bottom: 4px;
}

.divider {
  height: 1px;
  background-color: var(--border-color);
  margin: 20px 0;
}

.faq-item {
  margin-bottom: 10px;
}

.faq-item h4 {
  color: var(--primary-color);
  margin-bottom: 5px;
}

.faq-item p {
  margin: 0;
  color: var(--text-color);
}

.version-tag {
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-top: 5px;
}

.github-link {
  text-align: center;
  margin-top: 20px;
}

.github-link a {
  display: inline-flex;
  align-items: center;
  color: var(--text-color);
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.github-link a:hover {
  background-color: var(--secondary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.github-icon {
  margin-right: 6px;
  fill: var(--text-color);
}

.tool-links {
  margin-top: 5px;
}

.tool-link {
  display: inline-block;
  padding: 5px 10px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  margin-right: 5px;
  margin-bottom: 5px;
  transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
}

.tool-link:hover {
  background: linear-gradient(135deg, var(--accent-color) 0%, var(--primary-color) 100%);
  transform: translateY(-2px);
  box-shadow: 0 0 10px rgba(123, 104, 238, 0.5);
}

.thanks-section, .contact-section {
  background: var(--card-bg);
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: var(--box-shadow);
  border: 1px solid var(--border-color);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: slideUp 0.5s ease-out 0.4s both;
}

.thanks-section:hover, .contact-section:hover {
  transform: translateY(-5px);
  box-shadow: var(--glow-shadow), var(--box-shadow);
}

.thanks-section h3 {
  color: var(--primary-color);
  margin-bottom: 15px;
}

.repo-links {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.repo-link {
  position: relative;
  overflow: hidden;
}

.repo-link:hover {
  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--card-bg) 100%);
}

.contact-section {
  animation-delay: 0.5s;
}

.contact-section h3 {
  color: var(--primary-color);
  margin-bottom: 15px;
}

.contact-link {
  position: relative;
  overflow: hidden;
}

.contact-link:hover {
  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--card-bg) 100%);
}

.telegram-icon {
  margin-right: 10px;
  fill: var(--accent-color);
}

.contact-info {
  font-size: 14px;
  color: var(--text-color);
  opacity: 0.8;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .container {
    padding: 15px;
  }
  
  .logo {
    width: 80px;
    height: 80px;
  }
  
  h1 {
    font-size: 24px;
  }
  
  h2 {
    font-size: 18px;
  }
  
  .card, .info-card, .thanks-section, .contact-section {
    padding: 15px;
  }
  
  .tooltip {
    left: 0;
    width: 100%;
    top: 100%;
    margin-top: 5px;
  }
  
  .repo-link {
    width: 100%;
  }
}

/* 特小屏幕适配 */
@media (max-width: 480px) {
  .container {
    padding: 10px;
  }
  
  .logo {
    width: 60px;
    height: 60px;
  }
  
  h1 {
    font-size: 20px;
    margin-bottom: 15px;
  }
  
  .card, .info-card, .thanks-section, .contact-section {
    padding: 12px;
    margin-bottom: 15px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  input {
    padding: 10px;
    font-size: 14px;
  }
  
  .download-btn {
    padding: 10px;
    font-size: 14px;
  }
}

/* 超小屏幕适配（如iPhone SE等） */
@media (max-width: 375px) {
  .container {
    padding: 8px 5px;
  }
  
  .logo {
    width: 50px;
    height: 50px;
  }
  
  h1 {
    font-size: 18px;
    margin-bottom: 12px;
  }
  
  h2 {
    font-size: 16px;
    margin-bottom: 12px;
  }
  
  h3 {
    font-size: 15px;
  }
  
  h4 {
    font-size: 14px;
  }
  
  .card, .info-card, .thanks-section, .contact-section {
    padding: 10px 8px;
    margin-bottom: 12px;
  }
  
  .form-group {
    margin-bottom: 12px;
  }
  
  input {
    padding: 8px;
    font-size: 14px;
  }
  
  .download-btn {
    padding: 8px;
    font-size: 14px;
  }
  
  p, .contact-info {
    font-size: 13px;
  }
  
  .faq-item p, .tooltip {
    font-size: 12px;
  }
  
  .repo-links, .tool-links {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .repo-link, .tool-link, .contact-link {
    width: 100%;
    margin: 4px 0;
    font-size: 13px;
  }
}

/* 极小屏幕适配 */
@media (max-width: 320px) {
  .container {
    padding: 5px 3px;
  }
  
  .logo {
    width: 45px;
    height: 45px;
  }
  
  h1 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  
  h2 {
    font-size: 15px;
  }
  
  .card, .info-card, .thanks-section, .contact-section {
    padding: 8px 6px;
    margin-bottom: 10px;
  }
  
  .form-group {
    margin-bottom: 10px;
  }
  
  .form-group label {
    font-size: 13px;
    margin-bottom: 4px;
  }
  
  input {
    padding: 6px;
    font-size: 13px;
  }
  
  .download-btn {
    padding: 7px;
    font-size: 13px;
  }
  
  /* 减少气泡数量以提高性能 */
  .bubbles span:nth-child(n+31) {
    display: none;
  }
  
  /* 使布局更紧凑 */
  .divider {
    margin: 12px 0;
  }
}

/* 添加入场动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.process-info {
  margin-top: 15px;
  text-align: center;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: var(--secondary-color);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress {
  height: 100%;
  background: linear-gradient(90deg, var(--primary-color), var(--accent-color));
  border-radius: 4px;
  transition: width 0.5s ease;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.7;
  }
}
</style> 